import { Icon, IconButton, HStack } from '@genial/components';
import { BoxRadius, Color, Spacing, Typography } from '@genial/design-tokens';
import { useBreakpointValue } from '@genial/utils';
import { Text, Pressable } from 'native-base';
import React from 'react';

interface TableContentItemButtonProps {
  onPress: () => void;
  forceDesktop?: boolean;
}

export const TableContentItemButton: React.FC<TableContentItemButtonProps> = ({
  onPress,
  forceDesktop,
}) => {
  const isDesktop = useBreakpointValue({ base: false, lg: true });

  if (isDesktop || forceDesktop) {
    return (
      <Pressable testID="button-item" onPress={onPress}>
        <HStack alignItems="center" space={Spacing['inline.nano']}>
          <Text
            color={'brand.tertiary.principal'}
            variant="semibold"
            fontSize={Typography['fontsize.md']}>
            SELECIONAR
          </Text>
          <Icon name={'ArrowRight'} size={'xxxs'} color={Color['brand.tertiary.principal']} />
        </HStack>
      </Pressable>
    );
  }

  return (
    <IconButton
      testId="button-item"
      onPress={onPress}
      borderRadius={BoxRadius.sm}
      w="40px"
      h="40px"
      bgColor="brand.tertiary.principal"
      iconColor={Color['neutral.white']}
      icon="Check"
      iconSize="xxs"
    />
  );
};
